import PricePublicContext from "../../../context/PublicContext/PricePublicContext/PricePublicContext";
import MobilePriceView from "../MobilePriceView/MobilePriceView";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import PcPriceView from "../PcPriceView/PcPriceView";

const HomePublic = () => {
  return (
    <>
      <SiteTitle title="صفحه اصلی" />
      <div className="h-screen w-full">
        <div className="lg:flex hidden w-full h-full">
          <span className="h-full w-full overflow-y-auto bg-mainBackground">
            <PricePublicContext>
              <PcPriceView />
            </PricePublicContext>
          </span>
        </div>
        <div className="lg:hidden flex w-full h-full">
          <span className="h-full w-full rounded-lg bg-mainBackground">
            <PricePublicContext>
              <MobilePriceView />
            </PricePublicContext>
          </span>
        </div>
      </div>
    </>
  );
};

export default HomePublic;
